{
  "id": "occupations",
  "name": "Occupations",
  "standard": "ISCO",
  "version": "ISCO-08 (2021 structure workbook)",
  "granularity": "All 436 four-digit occupation unit groups",
  "license": "ILO publisher terms for pre-2023 data; no Creative Commons license asserted",
  "licenseUrl": "https://www.ilo.org/rights-and-permissions",
  "attribution": "International Labour Organization, International Standard Classification of Occupations 2008 (ISCO-08), English structure workbook. Classification codes and titles only; whitespace normalized.",
  "sourceUrl": "https://www.ilo.org/ilostat-files/ISCO/newdocs-08-2021/ISCO-08/ISCO-08%20EN%20Structure%20and%20definitions.xlsx",
  "sourceSha256": "df10744491b4216ed3580e8263b6324502e774c16667a1d7ecdbee50e85505e7",
  "retrievedAt": "2026-09-12",
  "options": [
    {
      "value": "2411",
      "label": "Accountants"
    },
    {
      "value": "4311",
      "label": "Accounting and Bookkeeping Clerks"
    },
    {
      "value": "3313",
      "label": "Accounting Associate Professionals"
    },
    {
      "value": "2655",
      "label": "Actors"
    },
    {
      "value": "3343",
      "label": "Administrative and Executive Secretaries"
    },
    {
      "value": "2431",
      "label": "Advertising and Marketing Professionals"
    },
    {
      "value": "1222",
      "label": "Advertising and Public Relations Managers"
    },
    {
      "value": "1343",
      "label": "Aged Care Service Managers"
    },
    {
      "value": "1311",
      "label": "Agricultural and Forestry Production Managers"
    },
    {
      "value": "7233",
      "label": "Agricultural and Industrial Machinery Mechanics and Repairers"
    },
    {
      "value": "3142",
      "label": "Agricultural Technicians"
    },
    {
      "value": "7127",
      "label": "Air Conditioning and Refrigeration Mechanics"
    },
    {
      "value": "3154",
      "label": "Air Traffic Controllers"
    },
    {
      "value": "3155",
      "label": "Air Traffic Safety Electronics Technicians"
    },
    {
      "value": "7232",
      "label": "Aircraft Engine Mechanics and Repairers"
    },
    {
      "value": "3153",
      "label": "Aircraft Pilots and Related Associate Professionals"
    },
    {
      "value": "3258",
      "label": "Ambulance Workers"
    },
    {
      "value": "6129",
      "label": "Animal Producers Not Elsewhere Classified"
    },
    {
      "value": "2656",
      "label": "Announcers on Radio, Television and Other Media"
    },
    {
      "value": "6123",
      "label": "Apiarists and Sericulturists"
    },
    {
      "value": "2514",
      "label": "Applications Programmers"
    },
    {
      "value": "1312",
      "label": "Aquaculture and Fisheries Production Managers"
    },
    {
      "value": "6221",
      "label": "Aquaculture Workers"
    },
    {
      "value": "2621",
      "label": "Archivists and Curators"
    },
    {
      "value": "0310",
      "label": "Armed Forces Occupations, Other Ranks"
    },
    {
      "value": "8219",
      "label": "Assemblers Not Elsewhere Classified"
    },
    {
      "value": "5161",
      "label": "Astrologers, Fortune-tellers and Related Workers"
    },
    {
      "value": "3421",
      "label": "Athletes and Sports Players"
    },
    {
      "value": "2266",
      "label": "Audiologists and Speech Therapists"
    },
    {
      "value": "2641",
      "label": "Authors and Related Writers"
    },
    {
      "value": "7512",
      "label": "Bakers, Pastry-cooks and Confectionery Makers"
    },
    {
      "value": "4211",
      "label": "Bank Tellers and Related Clerks"
    },
    {
      "value": "5132",
      "label": "Bartenders"
    },
    {
      "value": "5142",
      "label": "Beauticians and Related Workers"
    },
    {
      "value": "7234",
      "label": "Bicycle and Related Repairers"
    },
    {
      "value": "2131",
      "label": "Biologists, Botanists, Zoologists and Related Professionals"
    },
    {
      "value": "7221",
      "label": "Blacksmiths, Hammersmiths and Forging Press Workers"
    },
    {
      "value": "8154",
      "label": "Bleaching, Dyeing and Fabric Cleaning Machine Operators"
    },
    {
      "value": "4212",
      "label": "Bookmakers, Croupiers and Related Gaming Workers"
    },
    {
      "value": "7112",
      "label": "Bricklayers and Related Workers"
    },
    {
      "value": "3521",
      "label": "Broadcasting and Audio-visual Technicians"
    },
    {
      "value": "7411",
      "label": "Building and Related Electricians"
    },
    {
      "value": "2161",
      "label": "Building Architects"
    },
    {
      "value": "5153",
      "label": "Building Caretakers"
    },
    {
      "value": "9313",
      "label": "Building Construction Labourers"
    },
    {
      "value": "7119",
      "label": "Building Frame and Related Trades Workers Not Elsewhere Classified"
    },
    {
      "value": "7133",
      "label": "Building Structure Cleaners"
    },
    {
      "value": "8331",
      "label": "Bus and Tram Drivers"
    },
    {
      "value": "3339",
      "label": "Business Services Agents Not Elsewhere Classified"
    },
    {
      "value": "1219",
      "label": "Business Services and Administration Managers Not Elsewhere Classified"
    },
    {
      "value": "7511",
      "label": "Butchers, Fishmongers and Related Food Preparers"
    },
    {
      "value": "3323",
      "label": "Buyers"
    },
    {
      "value": "7522",
      "label": "Cabinet-makers and Related Workers"
    },
    {
      "value": "8322",
      "label": "Car, Taxi and Van Drivers"
    },
    {
      "value": "7115",
      "label": "Carpenters and Joiners"
    },
    {
      "value": "2165",
      "label": "Cartographers and Surveyors"
    },
    {
      "value": "5230",
      "label": "Cashiers and Ticket Clerks"
    },
    {
      "value": "8114",
      "label": "Cement, Stone and Other Mineral Products Machine Operators"
    },
    {
      "value": "3434",
      "label": "Chefs"
    },
    {
      "value": "3111",
      "label": "Chemical and Physical Science Technicians"
    },
    {
      "value": "3116",
      "label": "Chemical Engineering Technicians"
    },
    {
      "value": "2145",
      "label": "Chemical Engineers"
    },
    {
      "value": "3133",
      "label": "Chemical Processing Plant Controllers"
    },
    {
      "value": "8131",
      "label": "Chemical Products Plant and Machine Operators"
    },
    {
      "value": "2113",
      "label": "Chemists"
    },
    {
      "value": "1341",
      "label": "Child Care Service Managers"
    },
    {
      "value": "5311",
      "label": "Child Care Workers"
    },
    {
      "value": "9312",
      "label": "Civil Engineering Labourers"
    },
    {
      "value": "3112",
      "label": "Civil Engineering Technicians"
    },
    {
      "value": "2142",
      "label": "Civil Engineers"
    },
    {
      "value": "9112",
      "label": "Cleaners and Helpers in Offices, Hotels and Other Establishments"
    },
    {
      "value": "5151",
      "label": "Cleaning and Housekeeping Supervisors in Offices, Hotels and Other Establishments"
    },
    {
      "value": "3331",
      "label": "Clearing and Forwarding Aents"
    },
    {
      "value": "4419",
      "label": "Clerical Support Workers Not Elsewhere Classified"
    },
    {
      "value": "4229",
      "label": "Client Information Workers Not Elsewhere Classified"
    },
    {
      "value": "4413",
      "label": "Coding, Proofreading and Related Clerks"
    },
    {
      "value": "3322",
      "label": "Commercial Sales Representatives"
    },
    {
      "value": "0110",
      "label": "Commissioned Armed Forces Officers"
    },
    {
      "value": "3253",
      "label": "Community Health Workers"
    },
    {
      "value": "5162",
      "label": "Companions and Valets"
    },
    {
      "value": "3513",
      "label": "Computer Network and Systems Technicians"
    },
    {
      "value": "2523",
      "label": "Computer Network Professionals"
    },
    {
      "value": "7114",
      "label": "Concrete Placers, Concrete Finishers and Related Workers"
    },
    {
      "value": "3332",
      "label": "Conference and Event Planners"
    },
    {
      "value": "1323",
      "label": "Construction Managers"
    },
    {
      "value": "3123",
      "label": "Construction Supervisors"
    },
    {
      "value": "4222",
      "label": "Contact Centre Information Clerks"
    },
    {
      "value": "5244",
      "label": "Contact Centre Salespersons"
    },
    {
      "value": "5120",
      "label": "Cooks"
    },
    {
      "value": "7549",
      "label": "Craft and Related Workers not Elsewhere Classified"
    },
    {
      "value": "8343",
      "label": "Crane, hoist and related plant operators"
    },
    {
      "value": "2659",
      "label": "Creative and Performing Artists Not Elsewhere Classified"
    },
    {
      "value": "3312",
      "label": "Credit and Loans Officers"
    },
    {
      "value": "9211",
      "label": "Crop Farm Labourers"
    },
    {
      "value": "3351",
      "label": "Customs and Border Inspectors"
    },
    {
      "value": "7513",
      "label": "Dairy Products Makers"
    },
    {
      "value": "2653",
      "label": "Dancers and Choreographers"
    },
    {
      "value": "4132",
      "label": "Data Entry Clerks"
    },
    {
      "value": "2529",
      "label": "Database and Network Professionals Not Elsewhere Classified"
    },
    {
      "value": "2521",
      "label": "Database Designers and Administrators"
    },
    {
      "value": "4214",
      "label": "Debt Collectors and Related Workers"
    },
    {
      "value": "6223",
      "label": "Deep-sea Fishery Workers"
    },
    {
      "value": "3251",
      "label": "Dental Assistants and Therapists"
    },
    {
      "value": "2261",
      "label": "Dentists"
    },
    {
      "value": "2265",
      "label": "Dieticians and Nutritionists"
    },
    {
      "value": "3254",
      "label": "Dispensing Opticians"
    },
    {
      "value": "9111",
      "label": "Domestic Cleaners and Helpers"
    },
    {
      "value": "5152",
      "label": "Domestic Housekeepers"
    },
    {
      "value": "5243",
      "label": "Door-to-door Salespersons"
    },
    {
      "value": "3118",
      "label": "Draughtspersons"
    },
    {
      "value": "9332",
      "label": "Drivers of Animal-drawn Vehicles and Machinery"
    },
    {
      "value": "5165",
      "label": "Driving Instructors"
    },
    {
      "value": "2342",
      "label": "Early Childhood Educators"
    },
    {
      "value": "8342",
      "label": "Earthmoving and Related Plant Operators"
    },
    {
      "value": "2631",
      "label": "Economists"
    },
    {
      "value": "1345",
      "label": "Education Managers"
    },
    {
      "value": "2351",
      "label": "Education Methods Specialists"
    },
    {
      "value": "8212",
      "label": "Electrical and Electronic Equipment Assemblers"
    },
    {
      "value": "3113",
      "label": "Electrical Engineering Technicians"
    },
    {
      "value": "2151",
      "label": "Electrical Engineers"
    },
    {
      "value": "7413",
      "label": "Electrical Line Installers and Repairers"
    },
    {
      "value": "7412",
      "label": "Electrical Mechanics and Fitters"
    },
    {
      "value": "3114",
      "label": "Electronics Engineering Technicians"
    },
    {
      "value": "2152",
      "label": "Electronics Engineers"
    },
    {
      "value": "7421",
      "label": "Electronics Mechanics and Servicers"
    },
    {
      "value": "9629",
      "label": "Elementary Workers Not Elsewhere Classified"
    },
    {
      "value": "3333",
      "label": "Employment agents and contractors"
    },
    {
      "value": "2149",
      "label": "Engineering Professionals Not Elsewhere Classified"
    },
    {
      "value": "2263",
      "label": "Environmental and Occupational Health and Hygiene Professionals"
    },
    {
      "value": "3257",
      "label": "Environmental and Occupational Health Inspectors and Associates"
    },
    {
      "value": "2143",
      "label": "Environmental Engineers"
    },
    {
      "value": "2133",
      "label": "Environmental Protection Professionals"
    },
    {
      "value": "2132",
      "label": "Farming, Forestry and Fisheries Advisers"
    },
    {
      "value": "5241",
      "label": "Fashion and Other Models"
    },
    {
      "value": "9411",
      "label": "Fast Food Preparers"
    },
    {
      "value": "8151",
      "label": "Fibre Preparing, Spinning and Winding Machine Operators"
    },
    {
      "value": "6111",
      "label": "Field Crop and Vegetable Growers"
    },
    {
      "value": "4415",
      "label": "Filing and Copying Clerks"
    },
    {
      "value": "2654",
      "label": "Film, Stage and Related Directors and Producers"
    },
    {
      "value": "1211",
      "label": "Finance Managers"
    },
    {
      "value": "2413",
      "label": "Financial Analysts"
    },
    {
      "value": "1346",
      "label": "Financial and Insurance Services Branch managers"
    },
    {
      "value": "2412",
      "label": "Financial and Investment Advisers"
    },
    {
      "value": "5411",
      "label": "Fire Fighters"
    },
    {
      "value": "9216",
      "label": "Fishery and Aquaculture Labourers"
    },
    {
      "value": "3423",
      "label": "Fitness and Recreation Instructors and Programme Leaders"
    },
    {
      "value": "7122",
      "label": "Floor Layers and Tile Setters"
    },
    {
      "value": "7515",
      "label": "Food and Beverage Tasters and Graders"
    },
    {
      "value": "8160",
      "label": "Food and Related Products Machine Operators"
    },
    {
      "value": "5246",
      "label": "Food Service Counter Attendants"
    },
    {
      "value": "6210",
      "label": "Forestry and Related Workers"
    },
    {
      "value": "9215",
      "label": "Forestry Labourers"
    },
    {
      "value": "3143",
      "label": "Forestry Technicians"
    },
    {
      "value": "9333",
      "label": "Freight Handlers"
    },
    {
      "value": "7514",
      "label": "Fruit, Vegetable and Related Preservers"
    },
    {
      "value": "7544",
      "label": "Fumigators and Other Pest and Weed Controllers"
    },
    {
      "value": "8155",
      "label": "Fur and Leather Preparing Machine Operators"
    },
    {
      "value": "3433",
      "label": "Gallery, Museum and Library Technicians"
    },
    {
      "value": "9611",
      "label": "Garbage and Recycling Collectors"
    },
    {
      "value": "9214",
      "label": "Garden and Horticultural Labourers"
    },
    {
      "value": "6113",
      "label": "Gardeners, Horticultural and Nursery Growers"
    },
    {
      "value": "7532",
      "label": "Garment and Related Patternmakers and Cutters"
    },
    {
      "value": "4110",
      "label": "General Office Clerks"
    },
    {
      "value": "2211",
      "label": "Generalist Medical Practitioners"
    },
    {
      "value": "2114",
      "label": "Geologists and geophysicists"
    },
    {
      "value": "8181",
      "label": "Glass and Ceramics Plant Operators"
    },
    {
      "value": "7315",
      "label": "Glass Makers, Cutters, Grinders and Finishers"
    },
    {
      "value": "7125",
      "label": "Glaziers"
    },
    {
      "value": "3354",
      "label": "Government Licensing Officials"
    },
    {
      "value": "3359",
      "label": "Government Regulatory AssociatePprofessionals Not Elsewhere Classified"
    },
    {
      "value": "3353",
      "label": "Government Social Benefits Officials"
    },
    {
      "value": "3352",
      "label": "Government Tax and Excise Officials"
    },
    {
      "value": "2166",
      "label": "Graphic and Multimedia Designers"
    },
    {
      "value": "5141",
      "label": "Hairdressers"
    },
    {
      "value": "9331",
      "label": "Hand and Pedal Vehicle Drivers"
    },
    {
      "value": "9121",
      "label": "Hand Launderers and Pressers"
    },
    {
      "value": "9321",
      "label": "Hand Packers"
    },
    {
      "value": "7318",
      "label": "Handicraft Workers in Textile, Leather and Related Materials"
    },
    {
      "value": "7317",
      "label": "Handicraft Workers in Wood, Basketry and Related Materials"
    },
    {
      "value": "7319",
      "label": "Handicraft Workers Not Elsewhere Classified"
    },
    {
      "value": "3259",
      "label": "Health Associate Professionals Not Elsewhere Classified"
    },
    {
      "value": "5321",
      "label": "Health Care Assistants"
    },
    {
      "value": "2269",
      "label": "Health Professionals Not Elsewhere Classified"
    },
    {
      "value": "1342",
      "label": "Health Service Managers"
    },
    {
      "value": "8332",
      "label": "Heavy Truck and Lorry Drivers"
    },
    {
      "value": "5322",
      "label": "Home-based Personal Care Workers"
    },
    {
      "value": "1411",
      "label": "Hotel Managers"
    },
    {
      "value": "4224",
      "label": "Hotel Receptionists"
    },
    {
      "value": "7111",
      "label": "House Builders"
    },
    {
      "value": "1212",
      "label": "Human Resource Managers"
    },
    {
      "value": "6224",
      "label": "Hunters and Trappers"
    },
    {
      "value": "3132",
      "label": "Incinerator and Water Treatment Plant Operators"
    },
    {
      "value": "2141",
      "label": "Industrial and Production Engineers"
    },
    {
      "value": "7422",
      "label": "Information and Communications Technology Installers and Servicers"
    },
    {
      "value": "3511",
      "label": "Information and Communications Technology Operations Technicians"
    },
    {
      "value": "2434",
      "label": "Information and Communications Technology Sales Professionals"
    },
    {
      "value": "1330",
      "label": "Information and Communications Technology Service Managers"
    },
    {
      "value": "3512",
      "label": "Information and Communications Technology User Support Technicians"
    },
    {
      "value": "2356",
      "label": "Information Technology Trainers"
    },
    {
      "value": "6222",
      "label": "Inland and Coastal Waters Fishery Workers"
    },
    {
      "value": "4225",
      "label": "Inquiry Clerks"
    },
    {
      "value": "7124",
      "label": "Insulation Workers"
    },
    {
      "value": "3321",
      "label": "Insurance Representatives"
    },
    {
      "value": "3432",
      "label": "Interior Designers and Decorators"
    },
    {
      "value": "7313",
      "label": "Jewellery and Precious Metal Workers"
    },
    {
      "value": "2642",
      "label": "Journalists"
    },
    {
      "value": "2612",
      "label": "Judges"
    },
    {
      "value": "9412",
      "label": "Kitchen Helpers"
    },
    {
      "value": "2162",
      "label": "Landscape Architects"
    },
    {
      "value": "8157",
      "label": "Laundry Machine Operators"
    },
    {
      "value": "2611",
      "label": "Lawyers"
    },
    {
      "value": "3411",
      "label": "Legal and Related Associate Professionals"
    },
    {
      "value": "2619",
      "label": "Legal Professionals Not Elsewhere Classified"
    },
    {
      "value": "3342",
      "label": "Legal Secretaries"
    },
    {
      "value": "1111",
      "label": "Legislators"
    },
    {
      "value": "2622",
      "label": "Librarians and Related Information Professionals"
    },
    {
      "value": "4411",
      "label": "Library Clerks"
    },
    {
      "value": "3141",
      "label": "Life Science Technicians (excluding Medical)"
    },
    {
      "value": "8344",
      "label": "Lifting Truck Operators"
    },
    {
      "value": "6121",
      "label": "Livestock and Dairy Producers"
    },
    {
      "value": "9212",
      "label": "Livestock Farm Labourers"
    },
    {
      "value": "8311",
      "label": "Locomotive Engine Drivers"
    },
    {
      "value": "4412",
      "label": "Mail Carriers and Sorting Clerks"
    },
    {
      "value": "2421",
      "label": "Management and Organization Analysts"
    },
    {
      "value": "1120",
      "label": "Managing Directors and Chief Executives"
    },
    {
      "value": "9329",
      "label": "Manufacturing Labourers Not Elsewhere Classified"
    },
    {
      "value": "1321",
      "label": "Manufacturing Managers"
    },
    {
      "value": "3122",
      "label": "Manufacturing Supervisors"
    },
    {
      "value": "2120",
      "label": "Mathematicians, Actuaries and Statisticians"
    },
    {
      "value": "3115",
      "label": "Mechanical Engineering Technicians"
    },
    {
      "value": "2144",
      "label": "Mechanical Engineers"
    },
    {
      "value": "8211",
      "label": "Mechanical Machinery Assemblers"
    },
    {
      "value": "3214",
      "label": "Medical and Dental Prosthetic Technicians"
    },
    {
      "value": "3212",
      "label": "Medical and Pathology Laboratory Technicians"
    },
    {
      "value": "3256",
      "label": "Medical Assistants"
    },
    {
      "value": "3211",
      "label": "Medical Imaging and Therapeutic Equipment Technicians"
    },
    {
      "value": "3252",
      "label": "Medical Records and Health Information Technicians"
    },
    {
      "value": "3344",
      "label": "Medical Secretaries"
    },
    {
      "value": "9621",
      "label": "Messengers, Package Deliverers and Luggage Porters"
    },
    {
      "value": "8122",
      "label": "Metal Finishing, Plating and Coating Machine Operators"
    },
    {
      "value": "7211",
      "label": "Metal Moulders and Coremakers"
    },
    {
      "value": "7224",
      "label": "Metal Polishers, Wheel Grinders and Tool Sharpeners"
    },
    {
      "value": "8121",
      "label": "Metal Processing Plant Operators"
    },
    {
      "value": "3135",
      "label": "Metal Production Process Controllers"
    },
    {
      "value": "7223",
      "label": "Metal Working Machine Tool Setters and Operators"
    },
    {
      "value": "2112",
      "label": "Meteorologists"
    },
    {
      "value": "9623",
      "label": "Meter Readers and Vending-machine Collectors"
    },
    {
      "value": "3222",
      "label": "Midwifery Associate Professionals"
    },
    {
      "value": "2222",
      "label": "Midwifery Professionals"
    },
    {
      "value": "8112",
      "label": "Mineral and Stone Processing Plant Operators"
    },
    {
      "value": "8111",
      "label": "Miners and Quarriers"
    },
    {
      "value": "3117",
      "label": "Mining and metallurgical technicians"
    },
    {
      "value": "9311",
      "label": "Mining and Quarrying Labourers"
    },
    {
      "value": "2146",
      "label": "Mining Engineers, Metallurgists and Related Professionals"
    },
    {
      "value": "1322",
      "label": "Mining Managers"
    },
    {
      "value": "3121",
      "label": "Mining Supervisors"
    },
    {
      "value": "6130",
      "label": "Mixed Crop and Animal Producers"
    },
    {
      "value": "9213",
      "label": "Mixed Crop and Livestock Farm Labourers"
    },
    {
      "value": "6114",
      "label": "Mixed Crop Growers"
    },
    {
      "value": "8341",
      "label": "Mobile Farm and Forestry Plant Operators"
    },
    {
      "value": "7231",
      "label": "Motor Vehicle Mechanics and Repairers"
    },
    {
      "value": "8321",
      "label": "Motorcycle Drivers"
    },
    {
      "value": "7312",
      "label": "Musical Instrument Makers and Tuners"
    },
    {
      "value": "2652",
      "label": "Musicians, Singers and Composers"
    },
    {
      "value": "0210",
      "label": "Non-commissioned Armed Forces Officers"
    },
    {
      "value": "3221",
      "label": "Nursing Associate Professionals"
    },
    {
      "value": "2221",
      "label": "Nursing Professionals"
    },
    {
      "value": "9622",
      "label": "Odd Job Persons"
    },
    {
      "value": "3341",
      "label": "Office Supervisors"
    },
    {
      "value": "2267",
      "label": "Optometrists and Ophthalmic Opticians"
    },
    {
      "value": "3435",
      "label": "Other Artistic and Cultural Associate Professionals"
    },
    {
      "value": "2355",
      "label": "Other Arts Teachers"
    },
    {
      "value": "9129",
      "label": "Other Cleaning Workers"
    },
    {
      "value": "2353",
      "label": "Other Language Teachers"
    },
    {
      "value": "2354",
      "label": "Other Music Teachers"
    },
    {
      "value": "8183",
      "label": "Packing, Bottling and Labelling Machine Operators"
    },
    {
      "value": "7131",
      "label": "Painters and Related Workers"
    },
    {
      "value": "8143",
      "label": "Paper Products Machine Operators"
    },
    {
      "value": "2240",
      "label": "Paramedical Practitioners"
    },
    {
      "value": "4213",
      "label": "Pawnbrokers and Money-lenders"
    },
    {
      "value": "4313",
      "label": "Payroll Clerks"
    },
    {
      "value": "7535",
      "label": "Pelt Dressers, Tanners and Fellmongers"
    },
    {
      "value": "5329",
      "label": "Personal Care Workers in Health Services Not Elsewhere Classified"
    },
    {
      "value": "5169",
      "label": "Personal Services Workers Not Elsewhere Classified"
    },
    {
      "value": "2423",
      "label": "Personnel and Careers Professionals"
    },
    {
      "value": "4416",
      "label": "Personnel Clerks"
    },
    {
      "value": "5164",
      "label": "Pet Groomers and Animal Care Workers"
    },
    {
      "value": "3134",
      "label": "Petroleum and Natural Gas Refining Plant Operators"
    },
    {
      "value": "3213",
      "label": "Pharmaceutical Technicians and Assistants"
    },
    {
      "value": "2262",
      "label": "Pharmacists"
    },
    {
      "value": "2633",
      "label": "Philosophers, Historians and Political Scientists"
    },
    {
      "value": "3431",
      "label": "Photographers"
    },
    {
      "value": "8132",
      "label": "Photographic Products Machine Operators"
    },
    {
      "value": "3119",
      "label": "Physical and Engineering Science Technicians Not Elsewhere Classified"
    },
    {
      "value": "2111",
      "label": "Physicists and Astronomers"
    },
    {
      "value": "2264",
      "label": "Physiotherapists"
    },
    {
      "value": "3255",
      "label": "Physiotherapy Technicians and Assistants"
    },
    {
      "value": "7123",
      "label": "Plasterers"
    },
    {
      "value": "8142",
      "label": "Plastic Products Machine Operators"
    },
    {
      "value": "7126",
      "label": "Plumbers and Pipe Fitters"
    },
    {
      "value": "3355",
      "label": "Police Inspectors and Detectives"
    },
    {
      "value": "5412",
      "label": "Police Officers"
    },
    {
      "value": "2422",
      "label": "Policy Administration Professionals"
    },
    {
      "value": "1213",
      "label": "Policy and Planning Managers"
    },
    {
      "value": "7314",
      "label": "Potters and Related Workers"
    },
    {
      "value": "6122",
      "label": "Poultry Producers"
    },
    {
      "value": "3131",
      "label": "Power Production Plant Operators"
    },
    {
      "value": "7321",
      "label": "Pre-press Technicians"
    },
    {
      "value": "7311",
      "label": "Precision-instrument Makers and Repairers"
    },
    {
      "value": "2341",
      "label": "Primary School Teachers"
    },
    {
      "value": "7323",
      "label": "Print Finishing and Binding Workers"
    },
    {
      "value": "7322",
      "label": "Printers"
    },
    {
      "value": "5413",
      "label": "Prison Guards"
    },
    {
      "value": "3139",
      "label": "Process Control Technicians Not Elsewhere Classified"
    },
    {
      "value": "2163",
      "label": "Product and Garment Designers"
    },
    {
      "value": "7543",
      "label": "Product Graders and Testers (except Foods and Beverages)"
    },
    {
      "value": "4322",
      "label": "Production Clerks"
    },
    {
      "value": "1349",
      "label": "Professional Services Managers Not Elsewhere Classified"
    },
    {
      "value": "5419",
      "label": "Protective Services Workers Not Elsewhere Classified"
    },
    {
      "value": "2634",
      "label": "Psychologists"
    },
    {
      "value": "2432",
      "label": "Public Relations Professionals"
    },
    {
      "value": "8171",
      "label": "Pulp and Papermaking Plant Operators"
    },
    {
      "value": "8312",
      "label": "Railway Brake, Signal and Switch Operators"
    },
    {
      "value": "3334",
      "label": "Real Estate Agents and Property Managers"
    },
    {
      "value": "4226",
      "label": "Receptionists (general)"
    },
    {
      "value": "9612",
      "label": "Refuse Sorters"
    },
    {
      "value": "3413",
      "label": "Religious Associate Professionals"
    },
    {
      "value": "2636",
      "label": "Religious Professionals"
    },
    {
      "value": "1223",
      "label": "Research and Development Managers"
    },
    {
      "value": "1412",
      "label": "Restaurant Managers"
    },
    {
      "value": "1420",
      "label": "Retail and Wholesale Trade Managers"
    },
    {
      "value": "7215",
      "label": "Riggers and Cable Splicers"
    },
    {
      "value": "7121",
      "label": "Roofers"
    },
    {
      "value": "8141",
      "label": "Rubber Products Machine Operators"
    },
    {
      "value": "1221",
      "label": "Sales and Marketing Managers"
    },
    {
      "value": "5242",
      "label": "Sales Demonstrators"
    },
    {
      "value": "5249",
      "label": "Sales Workers Not Elsewhere Classified"
    },
    {
      "value": "4414",
      "label": "Scribes and Related Workers"
    },
    {
      "value": "2330",
      "label": "Secondary Education Teachers"
    },
    {
      "value": "4120",
      "label": "Secretaries (general)"
    },
    {
      "value": "3311",
      "label": "Securities and Finance Dealers and Brokers"
    },
    {
      "value": "5414",
      "label": "Security Guards"
    },
    {
      "value": "1112",
      "label": "Senior Government Officials"
    },
    {
      "value": "1114",
      "label": "Senior Officials of Special-interest Organizations"
    },
    {
      "value": "5245",
      "label": "Service Station Attendants"
    },
    {
      "value": "1439",
      "label": "Services Managers Not Elsewhere Classified"
    },
    {
      "value": "8153",
      "label": "Sewing Machine Operators"
    },
    {
      "value": "7533",
      "label": "Sewing, Embroidery and Related Workers"
    },
    {
      "value": "7213",
      "label": "Sheet Metal Workers"
    },
    {
      "value": "9334",
      "label": "Shelf Fillers"
    },
    {
      "value": "8350",
      "label": "Ships' Deck Crews and Related Workers"
    },
    {
      "value": "3152",
      "label": "Ships' Deck Officers and Pilots"
    },
    {
      "value": "3151",
      "label": "Ships' Engineers"
    },
    {
      "value": "7536",
      "label": "Shoemakers and Related Workers"
    },
    {
      "value": "8156",
      "label": "Shoemaking and Related Machine Operators"
    },
    {
      "value": "5223",
      "label": "Shop Sales Assistants"
    },
    {
      "value": "5222",
      "label": "Shop Supervisors"
    },
    {
      "value": "5221",
      "label": "Shopkeepers"
    },
    {
      "value": "7542",
      "label": "Shotfirers and Blasters"
    },
    {
      "value": "7316",
      "label": "Sign Writers, Decorative Painters, Engravers and Etchers"
    },
    {
      "value": "1344",
      "label": "Social Welfare Managers"
    },
    {
      "value": "2635",
      "label": "Social Work and Counselling Professionals"
    },
    {
      "value": "3412",
      "label": "Social Work Associate Professionals"
    },
    {
      "value": "2632",
      "label": "Sociologists, Anthropologists and Related Professionals"
    },
    {
      "value": "2519",
      "label": "Software and Applications Developers and Analysts Not Elsewhere Classified"
    },
    {
      "value": "2512",
      "label": "Software Developers"
    },
    {
      "value": "2352",
      "label": "Special Needs Teachers"
    },
    {
      "value": "2212",
      "label": "Specialist Medical Practitioners"
    },
    {
      "value": "3422",
      "label": "Sports Coaches, Instructors and Officials"
    },
    {
      "value": "1431",
      "label": "Sports, Recreation and Cultural Centre Managers"
    },
    {
      "value": "7132",
      "label": "Spray Painters and Varnishers"
    },
    {
      "value": "5211",
      "label": "Stall and Market Salespersons"
    },
    {
      "value": "8189",
      "label": "Stationary Plant and Machine Operators Not Elsewhere Classified"
    },
    {
      "value": "4312",
      "label": "Statistical, Finance and Insurance Clerks"
    },
    {
      "value": "3314",
      "label": "Statistical, Mathematical and Related Associate Professionals"
    },
    {
      "value": "8182",
      "label": "Steam Engine and Boiler Operators"
    },
    {
      "value": "4321",
      "label": "Stock Clerks"
    },
    {
      "value": "7113",
      "label": "Stonemasons, Stone Cutters, Splitters and Carvers"
    },
    {
      "value": "9510",
      "label": "Street and Related Service Workers"
    },
    {
      "value": "5212",
      "label": "Street Food Salespersons"
    },
    {
      "value": "9520",
      "label": "Street Vendors (excluding Food)"
    },
    {
      "value": "7214",
      "label": "Structural Metal Preparers and Erectors"
    },
    {
      "value": "6310",
      "label": "Subsistence Crop Farmers"
    },
    {
      "value": "6340",
      "label": "Subsistence Fishers, Hunters, Trappers and Gatherers"
    },
    {
      "value": "6320",
      "label": "Subsistence Livestock Farmers"
    },
    {
      "value": "6330",
      "label": "Subsistence Mixed Crop and Livestock Farmers"
    },
    {
      "value": "1324",
      "label": "Supply, Distribution and Related Managers"
    },
    {
      "value": "4227",
      "label": "Survey and Market Research Interviewers"
    },
    {
      "value": "9613",
      "label": "Sweepers and Related Labourers"
    },
    {
      "value": "2522",
      "label": "Systems Aministrators"
    },
    {
      "value": "2511",
      "label": "Systems Analysts"
    },
    {
      "value": "7531",
      "label": "Tailors, Dressmakers, Furriers and Hatters"
    },
    {
      "value": "5312",
      "label": "Teachers' Aides"
    },
    {
      "value": "2359",
      "label": "Teaching Professionals Not Elsewhere Classified"
    },
    {
      "value": "2433",
      "label": "Technical and Medical Sales Professionals (excluding ICT)"
    },
    {
      "value": "3522",
      "label": "Telecommunications Engineering Technicians"
    },
    {
      "value": "2153",
      "label": "Telecommunications Engineers"
    },
    {
      "value": "4223",
      "label": "Telephone Switchboard Operators"
    },
    {
      "value": "8159",
      "label": "Textile, Fur and Leather Products Machine Operators Not Elsewhere Classified"
    },
    {
      "value": "7516",
      "label": "Tobacco Preparers and Tobacco Products Makers"
    },
    {
      "value": "7222",
      "label": "Toolmakers and Related Workers"
    },
    {
      "value": "2164",
      "label": "Town and Traffic Planners"
    },
    {
      "value": "3324",
      "label": "Trade Brokers"
    },
    {
      "value": "3230",
      "label": "Traditional and Complementary Medicine Associate Professionals"
    },
    {
      "value": "2230",
      "label": "Traditional and Complementary Medicine Professionals"
    },
    {
      "value": "1113",
      "label": "Traditional Chiefs and Heads of Villages"
    },
    {
      "value": "2424",
      "label": "Training and Staff Development Professionals"
    },
    {
      "value": "2643",
      "label": "Translators, Interpreters and Other Linguists"
    },
    {
      "value": "4323",
      "label": "Transport Clerks"
    },
    {
      "value": "5112",
      "label": "Transport Conductors"
    },
    {
      "value": "5111",
      "label": "Travel Attendants and Travel Stewards"
    },
    {
      "value": "4221",
      "label": "Travel Consultants and Clerks"
    },
    {
      "value": "5113",
      "label": "Travel Guides"
    },
    {
      "value": "6112",
      "label": "Tree and Shrub Crop Growers"
    },
    {
      "value": "4131",
      "label": "Typists and Word Processing Operators"
    },
    {
      "value": "5163",
      "label": "Undertakers and Embalmers"
    },
    {
      "value": "7541",
      "label": "Underwater Divers"
    },
    {
      "value": "2310",
      "label": "University and Higher Education Teachers"
    },
    {
      "value": "7534",
      "label": "Upholsterers and Related Workers"
    },
    {
      "value": "3315",
      "label": "Valuers and Loss Assessors"
    },
    {
      "value": "9122",
      "label": "Vehicle Cleaners"
    },
    {
      "value": "2250",
      "label": "Veterinarians"
    },
    {
      "value": "3240",
      "label": "Veterinary Technicians and Assistants"
    },
    {
      "value": "2651",
      "label": "Visual Artists"
    },
    {
      "value": "2320",
      "label": "Vocational Education Teachers"
    },
    {
      "value": "5131",
      "label": "Waiters"
    },
    {
      "value": "9624",
      "label": "Water and Firewood Collectors"
    },
    {
      "value": "8152",
      "label": "Weaving and Knitting Machine Operators"
    },
    {
      "value": "2513",
      "label": "Web and Multimedia Developers"
    },
    {
      "value": "3514",
      "label": "Web Technicians"
    },
    {
      "value": "7212",
      "label": "Welders and Flame Cutters"
    },
    {
      "value": "8113",
      "label": "Well Drillers and Borers and Related Workers"
    },
    {
      "value": "9123",
      "label": "Window Cleaners"
    },
    {
      "value": "8172",
      "label": "Wood Processing Plant Operators"
    },
    {
      "value": "7521",
      "label": "Wood Treaters"
    },
    {
      "value": "7523",
      "label": "Woodworking Machine Tool Setters and Operators"
    }
  ]
}
